// DbgMilestoneMeetingCard.jsx
import React from 'react';
import './index.scss';

const DbgMilestoneMeetingCard = ({
  disabled = false,
  iconType = 'flag', // 'flag' 或 'meeting'
  dateText = '',
  status = 'done', // 'done', 'cancel', 'planned'
  statusText = '',
  content = '',
}) => {
  // 确保状态文本，如果没有传入则使用状态名
  const displayStatusText = statusText || status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <div className={`dbg-milestone-meeting-card ${disabled ? 'dbg--disabled' : ''}`}>
      {/* 两个icon： dbg--flag  dbg--meeting */}
      <div className={`dbg-milestone-meeting-hd dbg--${iconType}`}>
        <div className="dbg-milestone-meeting-title">
          <span>{dateText}</span>
        </div>
        {/* 三种颜色状态： dbg--done  dbg--cancel  dbg-planned */}
        <div className={`dbg-milestone-meeting-status dbg--${status}`}>{displayStatusText}</div>
      </div>
      <div className="dbg-milestone-meeting-bd">
        <div className="dbg-milestone-meeting-content">{content}</div>
      </div>
    </div>
  );
};

export default DbgMilestoneMeetingCard;
